export class TokenPasswordChangeRequest {
    public readonly email: string;

    constructor(email: string) {
        this.email = email;
    }
}
